import { useEffect, useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import UserContext from "../../contexts/UserContext";
import FetchUtil from "../../utils/FetchUtil";
import { emptyCache } from "../../utils/helper.js";
import { useTranslation } from 'react-i18next';

function Logoff() {
	const [error, setError] = useState("");
	const navigate = useNavigate();
	const userCtx = useContext(UserContext);
	const { t } = useTranslation();
	let redirectLogout = sessionStorage.getItem('redirectLogout');
	useEffect(() => {
		if (window.confirm(t("page.confirmationMessage"))) {
			userCtx.addUserName("");
			userCtx.addLoggedInUserId("");
			userCtx.addRole("");
			userCtx.addIsAuthenticated(false);
			userCtx.addIsSubscriptionValid(false);
			userCtx.addLang("");
			userCtx.addTosTimeStamp("");
			userCtx.addEnabledMFA(0);
			userCtx.clearStorage();
			if (redirectLogout && redirectLogout == "true") {
				localLogout();
			} else {
				globalLogout();
			}

		} else {
			navigate("/home");
		}

		function localLogout() {
			const requestOptions = {
				credentials: "same-origin",
				method: "POST",
				headers: { "Content-Type": "application/json" },
				body: JSON.stringify({ "source": "web" }),
			};

			try {
				FetchUtil.fetchAPI("Logoff", "/Service/UserService/Logoff", requestOptions, logoffSuccess, logoffFail);
			} catch (error) {
				setError(error.message);
				navigate("/home", {
					state: {
						errorMessage: error.message,
					},
				});
			}
		}

		function globalLogout() {
			const requestOptions = {
				credentials: "same-origin",
				method: "POST",
				headers: { "Content-Type": "application/json" },
				body: JSON.stringify({ "source": "web" }),
			};

			try {
				FetchUtil.fetchAPI("Logoff", "/Service/UserService/Logoff", requestOptions, globalLogoffSuccess, logoffFail);
			} catch (error) {
				setError(error.message);
				navigate("/home", {
					state: {
						errorMessage: error.message,
					},
				});
			}
		}
		function logoffFail(redirect) {
			emptyCache();
			navigate("/home", {
				state: {
					errorMessage: "",
				},
			});
		}
		function logoffSuccess(responseData) {
			emptyCache();
			let logOffResponse;
			if (responseData) {
				logOffResponse = responseData.logOffServiceResponse;
				if (logOffResponse && logOffResponse.errorCode === "0") {
					userCtx.addUserName("");
					userCtx.addLoggedInUserId("");
					userCtx.addRole("");
					userCtx.addIsAuthenticated(false);
					userCtx.addIsSubscriptionValid(false);
					userCtx.addLang("");
					userCtx.addTosTimeStamp("");
					userCtx.addEnabledMFA(0);
					userCtx.clearStorage();
					navigate("/home", {
						state: {
							errorMessage: "",
						},
					});
				} else if (logOffResponse && logOffResponse.errorCode === "114") {
					navigate("/home", {
						state: {
							errorMessage: t("error.sessionTimeout"),
						},
					});
				} else if (logOffResponse) {
					navigate("/home", {
						state: {
							errorMessage: "",
						},
					});
				} else {
					navigate("/home", {
						state: {
						},
					});
				}
			} else {
				navigate("/home", {
					state: {
					},
				});
			}
		}
		function globalLogoffSuccess(responseData) {
			emptyCache();
			let logOffResponse;
			if (responseData) {
				logOffResponse = responseData.logOffServiceResponse;
				if (logOffResponse && logOffResponse.errorCode === "0") {
					userCtx.addUserName("");
					userCtx.addLoggedInUserId("");
					userCtx.addRole("");
					userCtx.addIsAuthenticated(false);
					userCtx.addIsSubscriptionValid(false);
					userCtx.addLang("");
					userCtx.addTosTimeStamp("");
					userCtx.addEnabledMFA(0);
					userCtx.clearStorage();
					let logoutWindow = window.open("https://idecisionsciences.awsapps.com/start#/signout", "_newwin", "width=100,height=100");
					let timeoutVar = setTimeout(
						() => {
							logoutWindow.close();
							if (logoutWindow.closed) {
								navigate("/home", {
									state: {
										errorMessage: "",
									},
								});
							}
						},
						500
					);

				} else if (logOffResponse && logOffResponse.errorCode === "114") {
					navigate("/home", {
						state: {
							errorMessage: t("error.sessionTimeout"),
						},
					});
				} else {
					navigate("/home", {
						state: {
							errorMessage: "",
						},
					});
				}
			} else {
				setError(t("error.error"));
				navigate("/home", {
					state: {
						errorMessage: "",
					},
				});
			}
		}

	}, []);

	return (
		<div className="container">
			<div className="row">
				<div className="col">
					<div
						id="inerrorMessage"
						className={
							error
								? "errorblock"
								: "errorblock hide"
						}
					>
						{error}
					</div>
				</div>
			</div>
		</div>
	);
}
export default Logoff;